import React, {useState,  useEffect } from 'react';
import DeckGL, { MapView, PostProcessEffect } from 'deck.gl';

import { renderLayers } from "./RenderLayers";


import shaderModule from './shaderModules/blackwhite'


import styles from './Map.module.css';


const effect = new PostProcessEffect(shaderModule, {
    amount:1
});


// 背景マップに使用するMapboxのトークン設定
const MAPBOX_ACCESS_TOKEN = process.env.MAPBOX_ACCESS_TOKEN;

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    latitude: 40.70496049040556,
    longitude: -74.0120447808352,
    zoom: 15.5,
};


function Map() {
    const [viwState] = useState(INITIAL_VIEW_STATE);

    return (
        <div 
            className={styles.MapWrapper}
        >
            <DeckGL
                views={new MapView({ repeat: true })}
                effects={[effect]}
                initialViewState={viwState}
                controller={true}
                layers={renderLayers({})}
                //onViewStateChange={({viewState}) => console.log(viewState)}
            >
            </DeckGL>
            <div className="attribution">
                © <a
                    href="https://cloud.maptiler.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Maptiler
                </a>
            </div>            
        </div>
    );
}

export default Map;